import { themeDefaults } from '@youscience/theme';
import { styled } from '@mui/material';

import ActionButton from '@components/ActionButton';
export const sxStyles = {
  cipCodesWrap: {
    overflowY: 'scroll',
    maxHeight: '552px',
  },
  mobileFilters: {
    '.MuiDrawer-paper': {
      height: '100%',
      padding: '2.5rem 1.25rem',
    },
  },
  closeMobileFilter: {
    position: 'absolute',
    top: '1.375rem',
    left: '88%',
  },
  mainSectionWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
  },
  cardsWrap: {
    maxWidth: '952px',
    width: '100%',
  },
  filterSectionTitle: {
    marginBottom: '1.5rem',
  },
  filterSectionTitleWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '1.5rem',

    '& > div:last-of-type': {
      display: 'flex',

      '&:hover': {
        cursor: 'pointer',
      },
    },
  },
  searchWrap: {
    maxWidth: '284px',
    margin: '2rem 0 1.5rem 0',
  },
  alertWrap: {
    marginTop: '1.5rem',

    '.MuiAlert-root': {
      maxWidth: '284px',
      minWidth: 'auto',
    },
  },
  chipsWrap: {
    maxWidth: '284px',
    width: '100%',
  },
  filterChip: {
    margin: '0 0.25rem 0.5rem 0.25rem',
    maxWidth: '252px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  clearBtn: {
    marginTop: '1.5rem',
    marginBottom: '1.5rem',

    svg: {
      marginLeft: '0.5rem',
    },
  },
  checkboxGroup: {
    gap: '0.75rem',
    maxWidth: '252px',
    width: '100%',

    '& > label:first-of-type': {
      marginRight: 0,
    },
  },
  moneyRangeWrap: {
    marginTop: '2rem',
    marginBottom: '2rem',
    maxWidth: '248px',

    '& > span:last-of-type': {
      marginLeft: '0.75rem',
    },
  },
  moneyRangeTitleWrap: {
    display: 'flex',

    '& > div:last-of-type': {
      '&:hover': {
        cursor: 'pointer',
      },
    },
  },
  moneyRangeTitle: {
    padding: '0 0.5rem',
    marginBottom: '1.5rem',
    color: themeDefaults?.palette?.text?.secondary,
  },
  stateResidence: {
    maxWidth: '248px',
  },
  autocompleteOption: {
    '& > span:first-of-type': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  areaLabel: {
    maxWidth: '210px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

export const StyledMainSectionActions = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginBottom: '1.5rem',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },

  [theme.breakpoints.up('sm')]: {
    marginBottom: '1.5rem',
  },
}));

export const StyledMobileFilters = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '42px',
  maxWidth: '160px',
  width: '100%',
  padding: '0.5rem',
  border: `1px solid ${theme.palette.grey['300']}`,
  borderRadius: '2px',
  cursor: 'pointer',
  position: 'absolute',
  top: '-5rem',
}));

export const StyledScholarshipCardsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '2rem',

  [theme.breakpoints.up('md')]: {
    justifyContent: 'start',
  },
}));

export const StyledBottomPaginationWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'start',
  },

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'space-between',
  },
}));

export const StyledDesktopFiltersWrap = styled('div')(({ theme }) => ({
  width: 'auto',
  overflow: 'visible',
  visibility: 'visible',
  height: 'auto',

  [theme.breakpoints.down('md')]: {
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    visibility: 'hidden',
  },
}));

export const StyledFilterSectionWrap = styled('form')(({ theme }) => ({
  paddingRight: '0.5rem',
  marginTop: '0.5rem',
  minWidth: '284px',
  width: '100%',

  [theme.breakpoints.down('md')]: {
    marginRight: 0,
  },

  [theme.breakpoints.down('xs')]: {
    marginLeft: 0,
  },
}));

export const StyledMoreFiltersBtn = styled(ActionButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '248px',
  width: '100%',
  minHeight: '40px',
  marginTop: '2rem',
  fontSize: '0.875rem',
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  transition: 'background-color 0.5s',
  border: `1px solid ${theme.palette.primary.main}`,

  '& > svg:first-of-type': {
    marginLeft: '0.5rem',
  },

  '&:hover': {
    // TODO add color to library
    backgroundColor: '#EBF6F7',
  },
}));
